import type { UUID } from "@/core/types";

import { useCreateNoteAddendum } from "../../api/mutations/useCreateNoteAddendum";

import { AddendumForm } from "./AddendumForm";

type CreateAddendumProps = {
  credentials: string | undefined;
  noteId: UUID;
  onCancel: () => void;
  onSuccess: () => void;
  patientId: UUID;
  signature: string | undefined;
};

export function CreateAddendum({
  credentials,
  noteId,
  onCancel,
  onSuccess,
  patientId,
  signature,
}: CreateAddendumProps) {
  const { isPending, mutate } = useCreateNoteAddendum({ onSuccess });

  return (
    <AddendumForm
      isPending={isPending}
      mutate={(addendum) => mutate({ addendum, credentials, noteId, patientId, signature })}
      onCancel={onCancel}
    />
  );
}
